import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=1d80c15f&scoped=true&"
import script from "./file-item.vue?vue&type=script&lang=js&"
export * from "./file-item.vue?vue&type=script&lang=js&"
import style0 from "./file-item.vue?vue&type=style&index=0&id=1d80c15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80c15f",
  null
  
)

export default component.exports